import { faPlus } from "@fortawesome/pro-light-svg-icons"
import { MouseEvent } from "react"

import { IAction } from "@finanedi.es/front/common/organisms"
import { ILeyAntifraudeFormRepresentantesFormTemplateActionsProps } from "../interfaces"

export const leyAntifraudeFormRepresentantesFormTemplateActions = ({
  onAddRepresentante,
  onSubmit,
  loading,
}: ILeyAntifraudeFormRepresentantesFormTemplateActionsProps): IAction[] => [
  {
    label: "Añadir otro representante",
    buttonType: "none",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    icon: faPlus as any,
    className: "fs-w-full",
    wrapperClassName:
      "fs-w-full fs-border-b fs-border-gray-200 fs-border-solid fs-pb-4 fs-text-sm",
    onClick: (e: MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      onAddRepresentante()
    },
  },
  {
    label: "Generar y descargar PDF para firmar",
    className: "fs-w-full fs-justify-center",
    wrapperClassName: "fs-w-full fs-text-sm",
    loading,
    onClick: (e: MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      onSubmit()
    },
  },
]
